import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useSnackbar } from 'ui-components';
import { apiClientV2 } from '~/api/client';
import { Creator } from '~/clientApi/creator.model';

export interface Payload extends Partial<Creator> {
  id: string;
  creatorId: string;
}

type SearchResponse = {
  success: boolean;
};

type UseUpdateCreatorNoteProps = {
  disableSnackbar?: boolean;
};

export const useUpdateCreatorNote = ({
  disableSnackbar = false,
}: UseUpdateCreatorNoteProps = {}) => {
  const snackbar = useSnackbar();

  return useMutation<SearchResponse, AxiosError, Payload, SearchResponse>(
    (payload) => {
      return apiClientV2.put(
        `saved-lists/${payload.id}/creators/${payload.creatorId}`,
        {
          notes: payload.notes,
        },
      );
    },
    {
      onError: () => {
        if (disableSnackbar) return;
        snackbar.error({
          description: 'Something went wrong',
        });
      },
    },
  );
};
